import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { Data } from 'signup-constants/signupData/Data';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { getDomainFromEmail } from '../utils/getDomainFromEmail';
import { setEndpointTimeStarted } from '../store/http-responses/action-creators';
import { EndpointKey } from '../http/EndpointKey';
import { setSignupDataValue } from '../store/signup-data/action-creators';
import { isTestingOrInternalEmailDomain } from '../utils/isTestingOrInternalEmailDomain';
import { getEndpointRetries } from '../store/http-responses/selectors';
import { freemailDomains } from '../experiments/acq0143/freemailDomains';
const FREEMAIL_DOMAINS_SET = new Set(freemailDomains);
const isPersonalEmailDomain = domain => {
  return FREEMAIL_DOMAINS_SET.has(domain);
};
const fetchCompanyInfo = domain => {
  const COMPANY_INFO_URL = 'acquisition/v1/companyinfo/research';
  return noAuthApiClient.get(`${COMPANY_INFO_URL}?domain=${domain}`, {
    timeout: 8000
  });
};
export const getBreezeCompanyInfo = (state, dispatch) => {
  let domain = '';
  const retries = getEndpointRetries(state, EndpointKey.BreezeCompanyInfo);
  const email = getSignupDataValue(state, Data.Email);
  domain = getDomainFromEmail(email);
  if (retries > 0) {
    domain = getSignupDataValue(state, Data.CompanyDomain);
  }
  dispatch(setEndpointTimeStarted(EndpointKey.BreezeCompanyInfo, new Date()));
  if (isTestingOrInternalEmailDomain(domain)) {
    dispatch(setSignupDataValue(Data.CompanyDomain, 'hubspot-test.com'));
  } else {
    if (!isPersonalEmailDomain(domain)) {
      dispatch(setSignupDataValue(Data.CompanyDomain, domain));
    }
  }
  return fetchCompanyInfo(domain);
};